/* eslint-disable block-scoped-var */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import * as actionTypes from './actionTypes';

const axiosPayLoad = {
  checkBoxList: [],
  dropdown: [],
  errorMessagesInRedux: [],
  searchUnderThInvScreenObj: {},
  searchScreenObj: {},
  detailsScreenObj: {},
  perviousUnderThInvSearchRedux: [],
  selectedRebateProgram: [],
  auditTypeList: [],
  underThresholdSearchList: [],
  quarter: '',
  saveOrUpdateMessage: '',
  selectedIndex:[]
};

const reducer = (state = axiosPayLoad, action) => {
  switch (action.type) {
    case actionTypes.GET_COMMON_DROPDOWN_DATA_UTI:
      return {
        ...state,
        dropdown: action.dropdown,
      };
    case actionTypes.UNDER_THRESHOLD_INVOICE_SEARCH_TAB_DATA:
      return {
        ...state,
        searchUnderThInvScreenObj: action.searchUnderThInvScreenObj,
      };
    case actionTypes.UNDER_THRESHOLD_INVOICE_DETAILS_TAB_DATA:
      return {
        ...state,
        detailsScreenObj: action.detailsScreenObj,
      };
    case actionTypes.SEARCH_SCREEN_TAB_DATA:
      return {
        ...state,
        searchScreenObj: action.searchScreenObj,
      };
    case actionTypes.PERV_SEARCH_UNDER_TH_INV_DATA:
      return {
        ...state,
        perviousUnderThInvSearchRedux: action.perviousUnderThInvSearchRedux,
      };
    case actionTypes.SELECTED_REBATE_PROGRAM_UTI:
      return {
        ...state,
        selectedRebateProgram: action.selectedRebateProgram,
      };
    case actionTypes.GET_QUARTER_DATA_UTI:
      return {
        ...state,
        quarter: action.quarter,
      };
    case actionTypes.HANDLE_ERROR_MESSAGE_UTI:
      return { ...state, errorMessagesInRedux: action.errorMessagesInRedux };
    case actionTypes.GET_AUDIT_TYPE_CD_UTI:
      return {
        ...state,
        auditTypeList: action.auditTypeList,
      };
    case actionTypes.GET_UNDER_THRESHOLD_SEARCH_LIST:
      return {
        ...state,
        underThresholdSearchList: action.underThresholdSearchList,
      };
    case actionTypes.SAVE_OR_UPDATE:
      return { ...state, saveOrUpdateMessage: action.saveOrUpdateMessage };
    case actionTypes.SELECTED_INDEX:
      return { ...state, selectedIndex: [...state.selectedIndex, action.selectedIndex] };
    case actionTypes.CLEAR_SELECTED_INDEX:
        return { ...state, selectedIndex: [] };
    default:
      return state;
  }
};

export default reducer;
